import { GridPure, ModalUtil, SearchBarHLPure } from '../../pures'
import { Grid, useMediaQuery } from '@material-ui/core'
import { useTranslation } from 'react-i18next'
import { useMemo, useState } from 'react'

const BotAdministrationList = (props) => {
    // #region variables
    const {
        t,
        botList,
        updateBotStatus
    } = props

    const { t: tCommon } = useTranslation('common')
    const hideActions = useMediaQuery('(max-width: 820px)')

    const [searchBot, setSearchBot] = useState('')

    const handleChangeSearch = (e) => setSearchBot(e.target.value)

    const botGrid = useMemo(() => {
        if (!searchBot) return botList

        const lowercasedSearchBot = searchBot.toLowerCase()
        const filteredBotList = botList.filter(bot => bot.chatbotName.toLowerCase().includes(lowercasedSearchBot))
        return filteredBotList
    }, [botList, searchBot])
    // #endregion variables

    return (
        <>
            <Grid item xs={12} className='button-actions'>
                <SearchBarHLPure
                    placeholder={tCommon('search')}
                    onSearchChange={((e) => handleChangeSearch(e))}
                />
            </Grid>
            <Grid item xs={12}>
                <GridPure
                    {...props}
                    dataGrid={botGrid}
                    skip={0}
                    take={11}
                    rowsItems={[
                        {
                            field: 'chatbotName',
                            title: t('tableField.name'),
                            width: 200,
                            sorteable: true
                        },
                        {
                            field: 'createdDate',
                            title: t('tableField.createdDate'),
                            width: 200,
                            sorteable: true
                        },
                        {
                            field: 'deactivateDate',
                            title: t('tableField.deactivateDate'),
                            width: 100,
                            sorteable: true
                        },
                        {
                            field: 'active',
                            title: t('tableField.status'),
                            width: 100,
                            sorteable: true
                        },
                        {
                            field: 'actions',
                            title: t('tableField.actions'),
                            width: hideActions ? 80 : 100,
                            actions: true,
                            headerClassName: 'actionHeader'
                        }]}
                    actions={[
                        {
                            type: 'label',
                            value: (dataItem) => dataItem.active === t('enable') ? t('tableField.actionDisable') : t('tableField.actionEnable'),
                            onClick: (dataItem) => {
                                updateBotStatus(dataItem.id)
                            }
                        },
                    ]}
                />
            </Grid>
        </>
    )
}

export default BotAdministrationList